<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 9/10/2020
  -->

<template>
	<div class="fill-height-root" style="height: calc(100vh - 40px)">
<!--		<keep-alive>-->
			<TabbedLayout
				v-bind="$attrs"
				param-tab-name="category"
				routeName="CoachingMainCoach"
				:tabs="tabs"
			/>
<!--		</keep-alive>-->
	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import TabbedLayout from "@/core/components/Tabs/TabbedLayout.vue";
import TabItem from "@/core/components/Tabs/TabItem";

export default {
	name: "CoachingMain",
	components: {TabbedLayout},
	extends: BaseComponent,

	data() {
		return {
			tabs: [
				new TabItem("My Coaching", "processes"),
				new TabItem("Program Templates", "templates"),
			]
		}
	},
}
</script>

<style lang="scss">

</style>
